<template>
  <div class="video_page">
    <!-- 课程播放窗口 -->
    <div class="video_box">
      <div class="video_window">
        <!-- 左边播放信息 -->
        <div class="window_left">
          <!-- 视频信息 -->
          <div class="video_msg">
            <div class="video_title">{{cloudClassData.courseTitle}}</div>

            <div class="video_time">
              <span>{{cloudClassData.beginDate}}</span>
              <span>{{cloudClassData.beginTime}}</span>
            </div>

            <ul class="video_brief">
              <div class="brief_left">
                <li>
                  <img src="~@/assets/img/cloudClassCenter/geren.png" alt="">
                  <span>{{cloudClassData.lecturerName}}</span>
                </li>
                <li>
                  <img src="~@/assets/img/cloudClassCenter/xuexiao.png" alt="">
                  <span>{{cloudClassData.schoolName}}</span>
                </li>
                <li>
                  <img src="~@/assets/img/cloudClassCenter/nianji.png" alt="">
                  <span>{{cloudClassData.gradeName}}</span>
                </li>
                <li>
                  <img src="~@/assets/img/cloudClassCenter/kemu.png" alt="">
                  <span>{{cloudClassData.courseName}}</span>
                </li>
              </div>

              <div class="brief_right">
                <li>
                  <img ref="collect" class="collect_img" @click="_signUpBtn('0')" :src="collectUrl" alt="">
                  <span v-if="intoCloudData.collectNum">收藏 0{{intoCloudData.collectNum}} 人</span>
                  <span v-if="!intoCloudData.collectNum">收藏</span>
                </li>
                <li class="share">
                  <img src="~@/assets/img/cloudClassCenter/fenxiang.png" alt="">
                  <span>分享</span>
                  <div class="shareList">
                    <img @click="shareBtn('qq')" src="~@/assets/img/cloudClassCenter/qq.png" alt="">
                    <img @click="shareBtn('qzone')" src="~@/assets/img/cloudClassCenter/qzone.png" alt="">
                    <img @click="shareBtn('sina')" src="~@/assets/img/cloudClassCenter/sina.png" alt="">
                    <img @click="shareBtn('link')" src="~@/assets/img/cloudClassCenter/link.png" alt="">
                  </div>
                </li>
              </div>
            </ul>
          </div>

          <!-- 视频播放窗口 -->
          <div class="video_view">
            <VideoView :isEndLive='isEndLive' :playBackItem='playBackItem' :currentVideoTime.sync='currentVideoTime'
              :key='cloudClassId' :liveBarrage='liveBarrage' />
            <!-- 消息提醒 -->
            <div v-if="cloudClassData.type!=2&&PlayBackList.length==0" class="msgWarning_box">
              <MsgWarning v-if="playState=='0'||playState=='3'" :playState='playState' />
            </div>
          </div>
        </div>

        <!-- 右边聊天信息 -->
        <div class="window_right">

          <!-- 聊天视窗 -->
          <div class="chat_view">

            <!-- 回放 -->
            <div v-if="PlayBackList.length!='0'" class="play_back">
              <div class="play_back_title">回放选集</div>

              <div class="play_back_list">

                <div @click="PlayBackUrl(item,i)" class="play_back_item"
                  :class="{play_back_item_active:currentPlayBack==i}" v-for="(item,i) of PlayBackList"
                  :key='item.classVideoId'>
                  <div class="item_head">
                    <span>P{{i}}</span>
                  </div>
                  <div class="item_content">
                    <span>{{item.fileName}}</span>
                    <div>{{playBackDuration(item.duration)}}</div>
                  </div>
                </div>

              </div>

            </div>

            <!-- 聊天 -->
            <div ref="contentBox" class="content_list">
              <div class="content_item" v-for="(item,index) of chatList" :key='index'>
                <div>
                  <img v-if="item.role=='0'" src="~@/assets/img/cloudClassCenter/laoshi.png" alt="">
                  <img v-if="item.role=='2'" src="~@/assets/img/cloudClassCenter/system.png" alt="">
                  <span v-if="item.role=='2'" style="color:#f03d3d">系统提示~~</span>
                  <span v-if="item.role!='2'">{{item.name}}</span>
                </div>

                <span>
                  {{item.content}}
                </span>
              </div>
            </div>
          </div>

          <!-- 发送聊天消息 -->
          <div class="chat_send">
            <div class="emojiBox">
              <img @click="openEmoji" src="~@/assets/img/cloudClassCenter/biaqing.png" alt="">
              <div v-show="isEmoji" class="emoji_list">
                <div class="emoji_item" @click="selectEmoji(item)" v-for="item of emojiList" :key="item">
                  <span>{{item}}</span>
                </div>
              </div>
            </div>
            <el-input ref="chatInput" @keydown.native="handleKeyCode($event)" type="textarea" :rows="3"
              :readonly='isSpeakRead' :placeholder="placeholder" :show-word-limit='true' :maxlength="140" resize='none'
              size='medium' v-model="textMsg">
            </el-input>
            <el-button @click="handleBtn" :disabled="isSpeakRead" class="send_btn">发送</el-button>
          </div>

        </div>
      </div>
    </div>

    <!-- 课程评价课件等 -->
    <div class="video-page-bottom">
      <VideoComment :onlineNum='onlineNum' :cloudClassData='cloudClassData' :intoCloudData='intoCloudData' />

      <!-- 课件下载 -->
      <div class="download-box">
        <FileDownLoad :intoCloudData='intoCloudData' />
      </div>
    </div>

  </div>
</template>

<script>
import {
  myMsg,
  action,
  getClassDataById,
  intoCloudClass,
  classEvaluate
} from "@/network/cloudRequest/api";
import { getUserMsg } from "@/network/loginRequest/api";

import utils from "@/util/index";

import { send, connect, disconnect } from "@/util/WebSocket";

import VideoView from "./components/VideoView";
import MsgWarning from "./components/MsgWarning";

//课件下载--------------------------------------------
import FileDownLoad from "./components/videoPageBottom/FileDownload";
//课程评价和报名--------------------------------------------
import VideoComment from "./components/videoPageBottom/VideoComment";

export default {
  name: "VideoPage",
  components: {
    VideoView,
    MsgWarning,
    FileDownLoad,
    VideoComment
  },
  data() {
    return {
      //emoji文字库
      emojiList: [
        "😀",
        "😁",
        "😂",
        "😃",
        "😄",
        "😅",
        "😆",
        "😉",
        "😊",
        "😋",
        "😎",
        "😍",
        "😘",
        "😗",
        "😙",
        "😚",
        "☺",
        "😇",
        "😐",
        "😑",
        "😶",
        "😏",
        "😣",
        "😥",
        "😮",
        "😯",
        "😪",
        "😫",
        "😴",
        "😌",
        "😛",
        "😜",
        "😝",
        "😒",
        "😓",
        "😔",
        "😕",
        "😲",
        "😷",
        "😖",
        "😞",
        "😟",
        "😤",
        "😢",
        "😭",
        "😦",
        "😧",
        "😨",
        "😬",
        "😰",
        "😱",
        "😳",
        "😵",
        "😡",
        "😠"
      ],

      //是否显示emoji
      isEmoji: false,

      //用户发送的弹幕库
      liveBarrage: {},
      //当前视频播放时间毫秒
      currentVideoTime: "",
      //数据是否初始化完成
      isInit: false,

      video: "",
      activeName: "first",

      //用户名
      userName: "",
      //聊天窗口输入框数据
      textMsg: "",
      //是否发送过消息
      isSpeak: true,
      //是否滚动消息条
      isScroll: true,
      //发言间隔秒数
      sec: 5,

      //课程数据（课堂数据详情接口获取）
      cloudClassData: {},
      //进入课程数据（进入课堂接口获取）
      intoCloudData: {},

      //课程ID
      cloudClassId: "",
      //判断是否收藏过
      isCollect: false,
      //收藏图片
      collectUrl: require("@/assets/img/cloudClassCenter/shoucang.png"),
      //回放选集数据``````````````````````````````````````````````````
      //当前集数
      currentPlayBack: 0,
      //回放视频列表
      PlayBackList: [],
      //当前回放视频
      playBackItem: null,
      //socket````````````````````````````````````````````````````
      //在线人数
      onlineNum: 0,
      //聊天数组
      chatList: [],
      //游客id
      touristId: "",
      //连接断开参数
      socketMp: {
        //课程id
        cloudClassId: this.$route.query.cloudClassId,
        //游客(Tourist) 用户（CloudUser）  播主（PodCaster）
        role: this.$store.state.userId == "" ? "Tourist" : "CloudUser",
        //一对一聊天（single）,多对多弹幕（anyone）
        type: "anyone",
        //用户Id
        userId: this.$store.state.userId,
        //判断用户是否在线，登录状态
        state: "1",
        //用户名字
        name: "",
        //用户头像
        headPath: "",
        // token: utils.getSess("loginMessage"),
        token: utils.getSess("Authorization")
        // token: ""
      },
      //直播是否结束
      isEndLive: false
    };
  },

  created() {
    //初始化数据
    this.init();

    //监听刷新，然后断开链接
    window.addEventListener("beforeunload", () => {
      this.disconnectSocket();
    });
  },

  updated() {
    if (this.isScroll) {
      this.isScroll = false;
      //发言后滚动到底部
      this.$refs.contentBox.scrollTop = this.$refs.contentBox.scrollHeight;
    }
  },

  //组件销毁之后自动断开连接
  destroyed() {
    //离开后断开链接
    if (this.disconnectSocket) {
      this.disconnectSocket();
    }
  },

  methods: {
    //页码分享给qq微博第三方
    shareBtn(stype) {
      //qq空间接口的传参
      if (stype == "qzone") {
        window.open(
          `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${document.location.origin}/%23/cloud/video-page%3FcloudClassId%3D${this.$route.query.cloudClassId}&title=${this.cloudClassData.courseTitle}&desc=欢迎观看${this.cloudClassData.schoolName}学校-${this.cloudClassData.lecturerName}老师的-${this.cloudClassData.courseTitle}课`
        );
      }
      //新浪微博接口的传参
      if (stype == "sina") {
        window.open(
          `https://service.weibo.com/share/mobile.php?url=${document.location.origin}/%23/cloud/video-page%3FcloudClassId%3D${this.$route.query.cloudClassId}&sharesource=weibo&title=欢迎观看${this.cloudClassData.schoolName}学校-${this.cloudClassData.lecturerName}老师的-${this.cloudClassData.courseTitle}课`
        );
      }

      //qq好友接口的传参
      if (stype == "qq") {
        window.open(
          `https://connect.qq.com/widget/shareqq/index.html?url=${document.location.origin}/%23/cloud/video-page%3FcloudClassId%3D${this.$route.query.cloudClassId}&title=${this.cloudClassData.courseTitle}&summary=欢迎观看${this.cloudClassData.schoolName}学校-${this.cloudClassData.lecturerName}老师的-${this.cloudClassData.courseTitle}课`
        );
      }

      //复制链接
      if (stype == "link") {
        let input = document.createElement("input");
        input.value = `${document.location.origin}/#/cloud/video-page?cloudClassId=${this.$route.query.cloudClassId}`; // 修改文本框的内容
        document.body.append(input);
        input.select(); // 选中文本
        document.execCommand("Copy"); // 执行浏览器复制命令
        document.body.removeChild(input);
        utils.tips("warning", "链接复制成功，赶快发给小伙伴吧😀");
      }
    },

    //初始化数据
    init() {
      //初始化课程ID
      this.cloudClassId = this.$route.query.cloudClassId;

      //初始化课程数据（课堂数据详情接口获取）
      getClassDataById(this.cloudClassId).then(res => {
        if (res.data.success) {
          this.cloudClassData = res.data.data;
        }
      });

      //初始化进入课程数据（进入课堂接口获取）  //用户ID是否填写 待定
      intoCloudClass(this.cloudClassId).then(res => {
        if (res.data.success) {
          this.intoCloudData = res.data.data;
          //有回放才进来
          if (res.data.data.videoList) {
            this.PlayBackList = res.data.data.videoList;
            this.playBackItem = res.data.data.videoList[0];
          }
        }
      });

      //初始化用户名以及连接
      if (this.$store.state.userId != "") {
        getUserMsg(this.$store.state.userId).then(res => {
          if (res.data.success) {
            this.userName = res.data.data.name;
            //连接直播间
            this.$set(this.socketMp, "name", res.data.data.name);
            this.connectSocket();
          }
        });
      } else {
        this.userName = "tourist";
        let currentTime = new Date().getTime();
        let touristId;
        //判断是否存在游客id
        if (!sessionStorage.getItem("touristId")) {
          touristId = "" + currentTime + parseInt(Math.random() * 1000);
          sessionStorage.setItem("touristId", touristId);
        } else if (sessionStorage.getItem("touristId")) {
          touristId = sessionStorage.getItem("touristId");
        }
        this.$set(this.socketMp, "userId", touristId);
        this.$set(this.socketMp, "name", touristId);
        this.connectSocket();
      }

      //登录了才去判断
      if (this.$store.state.userId != "") {
        //判断是否收藏过
        let data1 = {
          //页码
          pageNum: "0",
          //当前页面数量
          pageSize: "0",
          //用户id
          subjectId: this.$store.state.userId,
          //用户类型 0=学生 1= 教师
          subjectType: "1",
          //0=收藏 ，1=课程
          type: "0"
          //0=1+N课堂，1=直播，2=点播 空=全部
          //classType
        };

        //判断是收藏过
        myMsg(data1).then(res => {
          if (res.data.success)
            res.data.data.list.forEach(item => {
              if (item.id == this.cloudClassId) {
                this.collectUrl = require("@/assets/img/cloudClassCenter/shoucang_active.png");
                this.isCollect = true;
              }
            });
        });
      }
    },

    //是否打开颜文字
    openEmoji() {
      if (!this.isSpeak) {
        this.isEmoji = !this.isEmoji;
      }
    },

    //选中的emoji
    selectEmoji(value) {
      if (!this.isSpeak) {
        this.textMsg = this.textMsg + value;
        this.isEmoji = false;
      }
    },

    //socket发送消息
    sendSocket() {
      let sensitiveWords = require("@/assets/js/sensitiveWords/sensitiveWords");
      sensitiveWords = sensitiveWords.default;
      sensitiveWords.forEach(item => {
        let reg = new RegExp(item, "g");
        if (this.textMsg.indexOf(item) != -1) {
          let result = this.textMsg.replace(reg, "**");
          this.textMsg = result;
        }
      });
      let createTime = new Date().getTime;
      //能发送消息 必定是用户
      var data = {
        //游客(Tourist) 用户（CloudUser）  播主（PodCaster）
        role: "CloudUser",
        //一对一聊天（single）,多对多弹幕（anyone）
        type: "anyone",
        //发送者id
        fromId: this.$store.state.userId,
        //消息状态（一对一的时候使用）
        newState: "",
        //发送者名字
        name: this.userName,
        //发送内容
        say: this.textMsg,
        //直播间id
        toId: this.cloudClassId,
        //标记
        prix: "topic",
        //发送者头像
        headPath: "",
        //视频当前播放时间
        timeTemp: this.currentVideoTime,
        //是否保存弹幕
        videoType: this.PlayBackList.length == 0 ? "0" : "2"
      };
      send(data);
    },

    //socket断开链接
    disconnectSocket() {
      disconnect(this.socketMp);
    },

    //socket连接
    connectSocket() {
      let id = this.$route.query.cloudClassId;
      connect(this.socketMp, id, this.socketCallBack);
    },

    //socket消息回调
    socketCallBack(response) {
      let data = JSON.parse(response.body);
      //游客(Tourist) 用户（CloudUser）  播主（PodCaster）
      this.onlineNum = data.count;
      //接收到消息，滚动到底部
      this.isScroll = true;
      //老师进入直播间(0)
      if (data.fromId.indexOf("PodCaster") !== -1) {
        this.chatList.push({
          name: data.name,
          content: data.say,
          role: "0"
        });
      }

      //老师发消息
      if (data.role === "PodCaster") {
        this.chatList.push({
          name: data.name,
          content: data.say,
          role: "0"
        });
      }

      //用户发消息(1)
      if (data.role == "CloudUser") {
        //弹幕
        this.liveBarrage = data;
        this.chatList.push({
          name: data.name,
          content: data.say,
          role: "1"
        });
      }

      //系统消息
      if (data.role == "system") {
        // 直播结束
        if (data.say == "system_reload") {
          this.init();
          this.isEndLive = true;
        } else {
          this.chatList.push({
            name: data.name,
            content: data.say,
            role: "2"
          });
        }
      }
    },

    //收藏该课程按钮
    _signUpBtn(type) {
      if (this.$store.state.isLogin) {
        let dateTime = new Date().getTime();
        let fd = new FormData();
        fd.append("actionDate", utils.timeFormat(dateTime));
        //	0=教材收藏，1=课件收藏，2=图书收藏，3=题库收藏， 4=课堂
        fd.append("collectType", "4");
        fd.append("comment", "课堂");
        fd.append("id", this.cloudClassId);
        fd.append("subjectId", this.$store.state.userId);
        fd.append("subjectType", "1");
        //操作类型（0=收藏，1=报名，2=回看提醒）
        fd.append("type", type);

        //未收藏过则进来
        if (!this.isCollect || type == "1") {
          action(fd).then(res => {
            if (res.data.success) {
              if (type == "0") {
                //收藏成功更换
                this.isCollect = true;
                this.collectUrl = require("@/assets/img/cloudClassCenter/shoucang_active.png");
                utils.tips("success", "收藏成功");
              }
              if (type == "1") {
                this.isSignUp = true;
                utils.tips("success", "报名成功");
              }

              if (type == "2") {
                // this.isSignUp = true;
                utils.tips("success", "回看提醒设置成功");
              }
            }
          });
        } else if (this.isCollect) {
          utils.tips("warning", "您已收藏");
        }
      } else {
        utils.tips("warning", "请您先登录");
      }
    },

    //发言
    handleKeyCode(e) {
      if (!this.isSpeak) {
        let code = e.keyCode;
        let shift = e.shiftKey;
        if (code == "13" && !shift) {
          e.preventDefault();
          this.handleBtn();
        }
      }
    },

    //点击发送按钮发言
    handleBtn() {
      if (this.textMsg != "") {
        this.sendSocket();
        this.isSpeak = true;
        this.textMsg = "";
      } else {
        utils.tips("warning", "请输入内容");
      }
    },

    //回放播放内容·························
    //当前播放视频
    PlayBackUrl(item, i) {
      this.playBackItem = item;
      this.currentPlayBack = i;
    },

    //回放视频持续时间
    playBackDuration(s) {
      return utils.formatSeconds(s);
    }
  },

  computed: {
    //是否还可以加载
    isAddMark() {
      return this.currentNum >= this.markList.length;
    },

    //发言输入框默认信息
    placeholder() {
      if (this.$store.state.isLogin) {
        if (this.isSpeak) {
          if (this.sec == 5) {
            let flag = setInterval(() => {
              this.sec -= 1;
              if (this.sec <= 0) {
                this.isSpeak = false;
                this.sec = 5;
                clearInterval(flag);
              }
            }, 1000);
          }
          return this.sec + "秒后可发言";
        } else {
          return "请文明用语！";
        }
      } else {
        return "请您先登录！";
      }
    },

    //发言输入框是否可读
    isSpeakRead() {
      if (this.$store.state.isLogin && !this.isSpeak) {
        return false;
      } else {
        return true;
      }
    },

    //播放状态
    playState() {
      //<!-- 0未直播 1直播中 2下课中 3直播结束  -->
      if (this.cloudClassData.state == "0") return this.cloudClassData.state;
      if (this.cloudClassData.state == "1") return this.cloudClassData.state;
      if (this.cloudClassData.state == "2") return "3";
      if (this.cloudClassData.state == "3") return this.cloudClassData.state;
    }
  }
};
</script>

<style lang='less' scoped>
.video_page {
  min-height: 1400px;
}

.video_box {
  min-width: 1200px;
  height: 661px;

  background-color: #353235;
}

.video_window {
  display: flex;

  margin: 0 auto;
  width: 1200px;
  height: 661px;

  justify-content: center;
  align-items: center;

  .window_left {
    width: 848px;
    height: 610px;

    .video_msg {
      display: flex;

      margin-bottom: 10px;
      padding-left: 20px;
      height: 120px;

      font-family: Microsoft YaHei;
      font-weight: 400;

      color: rgba(204, 204, 204, 1);
      background-color: #454246;

      flex-direction: column;
      justify-content: center;

      .video_title {
        font-size: 20px;
        line-height: 20px;
      }

      .video_time {
        margin: 19px 0 21px;

        font-size: 12px;
        line-height: 12px;

        span {
          margin-right: 17px;
        }
      }

      .video_brief {
        display: flex;

        list-style: none;

        font-size: 14px;
        line-height: 14px;

        justify-content: space-between;

        .collect_img {
          cursor: pointer;
        }

        .brief_left {
          display: flex;
          li {
            display: flex;

            margin-right: 38px;

            fill: 1;
            align-items: center;

            img {
              margin-right: 10px;
            }
          }
        }

        .brief_right {
          display: flex;

          align-items: center;
          justify-content: space-between;

          li {
            display: flex;

            margin-right: 38px;

            fill: 1;
            align-items: center;

            img {
              margin-right: 10px;
            }
          }

          .share {
            position: relative;

            cursor: pointer;

            .shareList {
              display: none;

              position: absolute;
              top: -30px;
              left: -45px;

              justify-content: space-between;

              img {
                width: 25px;
                height: 25px;

                cursor: pointer;
              }
            }
          }

          .share:hover {
            .shareList {
              display: flex;

              height: 50px;
            }
          }
        }
      }
    }

    .video_view {
      position: relative;

      width: 848px;
      height: 477px;

      background-color: #55595c;

      .msgWarning_box {
        display: flex;

        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        pointer-events: none;

        justify-content: center;
        align-items: center;
      }
    }
  }

  .window_right {
    margin-left: 11px;
    width: 340px;
    height: 610px;

    .chat_view {
      display: flex;

      padding: 10px 0 10px 10px;
      height: 470px;

      font-family: Microsoft YaHei;
      font-size: 12px;
      font-weight: 400;

      color: #e1e1e1;
      background-color: #454246;

      flex-direction: column;

      .play_back {
        height: 250px;

        font-family: Microsoft YaHei;
        font-size: 16px;
        font-weight: 400;

        color: #fff;

        .play_back_title {
          position: relative;

          margin-bottom: 11px;
        }

        .play_back_title::after {
          position: absolute;
          bottom: -11px;
          left: -10px;

          width: 341px;
          height: 1px;

          background-color: #878787;

          content: "";
        }

        .play_back_title::before {
          position: absolute;
          bottom: -230px;
          left: -10px;

          width: 341px;
          height: 11px;

          background-color: #333;

          content: "";
        }

        // 设置滚动条样式··································
        .play_back_list::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
        }

        .play_back_list::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;

          background: #535353;

          -webkit-box-shadow: inset 0 0 5px #24ba58;
          box-shadow: inset 0 0 5px #24ba58;
        }

        .play_back_list::-webkit-scrollbar-track {
          border-radius: 20px;

          background: #444;
          /*滚动条里面轨道*/

          -webkit-box-shadow: inset 0 0 5px #444;
          box-shadow: inset 0 0 5px #444;
        }
        // 设置滚动条样式··································

        .play_back_list {
          overflow-x: hidden;
          overflow-y: auto;

          position: relative;

          margin-top: 25px;
          height: 180px;

          font-size: 14px;

          .play_back_item:nth-child(odd) {
            margin: 10px 0;
          }

          .play_back_item {
            display: flex;

            border-radius: 3px;
            width: 311px;
            height: 50px;

            cursor: pointer;

            align-items: center;

            .item_head {
              display: flex;

              margin-right: 10px;
              margin-left: 10px;
              border-radius: 3px;
              width: 47px;
              height: 23px;

              background-color: #dadada;

              justify-content: center;
              align-items: center;

              span {
                font-family: Microsoft YaHei;
                font-size: 14px;
                font-weight: 400;

                color: #333;
              }
            }

            .item_content {
              span {
                display: block;
                overflow: hidden;

                width: 240px;

                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }

          .play_back_item_active {
            background-color: #7f7f7f;
          }
        }
      }

      // 设置滚动条样式··································
      .content_list::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
      }

      .content_list::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;

        background: #535353;

        -webkit-box-shadow: inset 0 0 5px #24ba58;
        box-shadow: inset 0 0 5px #24ba58;
      }

      .content_list::-webkit-scrollbar-track {
        border-radius: 20px;

        background: #444;
        /*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px #444;
        box-shadow: inset 0 0 5px #444;
      }
      // 设置滚动条样式··································

      .content_list {
        overflow: auto;

        margin-top: 10px;

        flex: 1;
      }
      .content_item {
        margin-bottom: 20px;

        div {
          display: flex;

          margin-bottom: 7px;

          color: #17e966;

          align-items: center;

          img {
            margin-right: 4px;
            width: 14px;
            height: 14px;
          }
        }
      }
    }

    .chat_send {
      position: relative;

      margin-top: 2px;
      padding: 6px 8px 9px 11px;
      height: 138px;

      font-family: Microsoft YaHei;
      font-size: 12px;
      font-weight: 400;

      color: #878787;
      background-color: #454246;

      .emojiBox {
        position: relative;

        margin-bottom: 2px;
        width: 20px;
        height: 20px;

        cursor: pointer;

        .emoji_list {
          display: flex;

          position: absolute;
          right: -225px;
          bottom: 22px;
          z-index: 1;

          border: 1px solid #ccc;
          padding: 2px;
          width: 450px;

          background-color: #535353;

          cursor: default;

          flex-wrap: wrap;

          .emoji_item {
            width: 40px;
            height: 40px;

            font-size: 20px;
            line-height: 30px;
            text-align: center;

            span {
              cursor: pointer;
            }
          }
        }
      }

      .send_btn {
        display: flex;

        position: absolute;
        right: 8px;
        bottom: 9px;

        border: 0;
        border-radius: 3px;
        width: 56px;
        height: 24px;

        font-size: 12px;
        font-weight: 400;

        color: #fff;
        background-color: #24ba58;

        outline: none;

        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      /deep/ .el-textarea__inner {
        border: 0;
        padding: 0;
        width: 320px;
        height: 73px;

        color: #c0c4cc;
        background-color: #454246;

        outline: 0;
      }

      /deep/ .el-textarea__inner::-webkit-scrollbar {
        opacity: 0;
      }

      /deep/ .el-textarea__inner:focus {
        border: 0;

        outline: 0;
      }

      /deep/ .el-input__count {
        background: 0;
      }
    }
  }
}

.video-page-bottom {
  display: flex;

  margin: 32px auto;
  width: 1200px;
}

//修改UI样式
/deep/ .el-tabs__item.is-active {
  color: #24ba58;
}

/deep/ .el-tabs__item:hover {
  color: #24ba58;
}

/deep/ .el-tabs__active-bar {
  background-color: #24ba58;
}
</style>